import { CerFormAdapter } from "@cer/cer-form/cer-form-adapter";
import { CerFormView } from "@cer/cer-form/cer-form-view";

export class SalesPaymentTypeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'salg-betalingstyper', dataApiName: 'SalesPaymentType', text: 'Salg betalingstyper',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      },
      fieldMetadata: [
        { name: 'createInvoice', text: 'Dan faktura', format: 'CheckBox', defaultValue: true },
        { name: 'paymentCapture', text: 'Capture betaling', format: 'CheckBox', defaultValue: false }
      ]
    });

  }
}
